import { Injectable } from '@angular/core';

import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class LoggerService {
  debug(message: string, ...data: string[]): void {
    if (!this.shouldLog()) {
      return;
    }

    console.debug(`[${environment.name}] ${message}`, ...data);
  }

  info(message: string, ...data: string[]): void {
    if (!this.shouldLog()) {
      return;
    }

    console.info(`[${environment.name}] ${message}`, ...data);
  }

  warn(message: string, ...data: string[]): void {
    if (!this.shouldLog()) {
      return;
    }

    console.warn(`[${environment.name}] ${message}`, ...data);
  }

  error(message: string, ...data: string[]): void {
    if (!this.shouldLog()) {
      return;
    }

    console.error(`[${environment.name}] ${message}`, ...data);
  }

  private shouldLog(): boolean {
    return environment.logging.enabled && !environment.production;
  }
}
